import { gql } from "@/gql/__generated__";
import { ToolHashType } from "@/gql/__generated__/graphql";
import { useQuery } from "@apollo/client";

const JOB = gql(`
  query JOB($toolHash: ID!, $hashType: ToolHashType!) {
    job(toolHash: $toolHash, hashType: $hashType) {
      __typename
      id
      status
      proxyUrl
    }
  }
`);

export const useJob = ({
  toolHash,
  hashType
}: {
  toolHash: string;
  hashType: ToolHashType;
}) =>
  useQuery(JOB, {
    variables: { toolHash, hashType },
    skip: !toolHash,
    notifyOnNetworkStatusChange: true,
    pollInterval: 1000
  });
